<mat-dialog-content style="min-width:800px">

  <h1 style="font-weight: bold;">{{ 'T4.Campaigns.CampaignList.lblcreatecampaigntitle' | translate : 'Create campaign' }}</h1>

  <t4-container title="{{ 'T4.Campaigns.CampaignList.lblcreatehead' | translate : 'Head' }}" style="min-width:500px; max-height:800px;">
    <div class="row settingRow">
      <div class="col-3 rowinfo" style="text-align:right; top:25px;">{{'T4.Campaigns.createCampaign.lbltype' |translate : 'Type' }}<mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipType' | translate : 'What kind of campaign.' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="campaignInfo.Type">
            <mat-option [value]="2" style="background-color:white; margin-top:3px;">{{'T4.Campaigns.createCampaign.lblcampaign' |translate : 'Campaign' }}</mat-option>
            <mat-option [value]="3" style="background-color:white; margin-top:3px;">{{'T4.Campaigns.createCampaign.lblcampaigntemplate' |translate : 'Campaign template' }}</mat-option>
            <mat-option [value]="1" style="background-color:white; margin-top:3px;">{{'T4.Campaigns.createCampaign.lblvoucherstemplate' |translate : 'Voucher template' }}</mat-option>
            <mat-option [value]="4" style="background-color:white; margin-top:3px;">{{'T4.Campaigns.createCampaign.lblinvitefriends' |translate : 'Invite friends' }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row settingRow">
      <div class="col-3 rowinfo" style="text-align:right; top:20px;">{{'T4.Campaigns.createCampaign.lblreason' |translate : 'Reason' }}<mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipreasoncode' | translate : 'The reason for the discount' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <mat-select [(ngModel)]="campaignInfo.ReasonId">
            @for(r of Reasons; track r.Id){
            <mat-option [value]="r.Id">{{r.Reason}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row settingRow">
      <div class="col-3 rowinfo" style="text-align:right; top:25px;">{{'T4.Campaigns.createCampaign.lblcampaignname' |translate : 'Campaign name' }}<mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipname' | translate : 'Campaign name' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="text" matInput [formControl]="inputdiscountcode" [(ngModel)]="campaignInfo.DiscountCode" value="" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errDiscoundNameLength' | translate : 'Discount name have to have the length of 1 to 15 letters' }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row settingRow">
      <div class="col-3 rowinfo" style="text-align:right; top:25px;">{{'T4.Campaigns.createCampaign.lblComment' |translate : 'Comment' }}<mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipCommentDescription' | translate : 'A short description for the campaign.' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="text" matInput [(ngModel)]="campaignInfo.Comment" value="" />
        </mat-form-field>
      </div>
    </div>

  </t4-container>

  <t4-container title="{{ 'T4.Campaigns.CampaignList.lblcreatecampaignvalid' | translate : 'Valid' }}" style="min-width:500px;">
    @if(campaignInfo.Type == 2) {
    <div class="row settingRow">
      <div class="col-3 rowinfo" style="text-align:right; top:25px;">{{'T4.Campaigns.createCampaign.lblvalidfrom' |translate : 'Valid From' }}<mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipstartfrom' | translate : 'Campaign is valid from date' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="text" #fromDate matInput [formControl]="inputValidFrom" [(ngModel)]="campaignInfo.ValidFrom" [matDatepicker]="fromDatepicker" value="" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errInvalidFromdate' | translate : 'From date is invalid' }}</mat-error>
          <mat-datepicker-toggle matSuffix #fromdate [for]="fromDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #fromDatepicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
    }

    @if(campaignInfo.Type != 2){
    <div class="row settingRow">
      <div class="col-3 rowinfo" style="text-align:right; top:20px;">{{'T4.Campaigns.createCampaign.lblnumbervalidmonths' |translate : 'Number of valid months' }}<mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipmonths' | translate : 'Campaign valid months' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input [formControl]="inputMonths" placeholder="{{ 'T4.Campaigns.CampaignList.validmonth' | translate : 'Months' }}" type="text" matInput [(ngModel)]="ValidMonths" value="" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errValidThroughmonths' | translate : 'Through months is invalid. Only numbers' }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    }

    @if(campaignInfo.Type == 2) {
    <div class="row settingRow">
      <div class="col-3 rowinfo" style="text-align:right; top:20px;">{{'T4.Campaigns.createCampaign.lblvalidThrough' |translate : 'Valid To' }}<mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipValidThrough' | translate : 'Campaign is valid to selected date' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="text" #toDate matInput [formControl]="inputValidThrough" [(ngModel)]="campaignInfo.ValidThrough" value="" [matDatepicker]="toDatepicker" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errValidthrough' | translate : 'Date is invalid. XXXX-XX-XX' }}</mat-error>
          <mat-datepicker-toggle matSuffix [for]="toDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #toDatepicker></mat-datepicker>
        </mat-form-field>

      </div>

    </div>
    }

  </t4-container>

  <t4-container title="{{'T4.Campaigns.Campaign.valuetitle' |translate : 'Value' }}">
    <div class="row settingRow">
      <div class="col-3" style="text-align:right; top:20px;"></div>
      <div class="col-9">
        <mat-radio-group [(ngModel)]="campaignInfo.ValueType">
          <mat-radio-button [value]="0" #rdbPercent style="margin-right: 15px;">{{'T4.Campaigns.createCampaign.lblpercent' |translate : 'Percent' }}</mat-radio-button>
          <mat-radio-button [value]="1" #rdbValue style="margin-right: 15px;">{{'T4.Campaigns.createCampaign.lblamount' |translate : 'Amount' }}</mat-radio-button>
          <mat-radio-button [value]="2" #rdbTime>{{'T4.Campaigns.createCampaign.lblHours' |translate : 'Hours' }}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    @if(rdbValue.checked) {
    <div class="row settingRow">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblvalue' |translate : 'Value' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipValueDesc' | translate : 'Campaign discount set in direct value' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="text" [formControl]="amountValue" #amount matInput [(ngModel)]="campaignInfo.Value" value="" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errgreaterzeroexpression' | translate : 'Value must be only numbers and greater then 0' }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    }

    @if(rdbPercent.checked) {
    <div class="row settingRow">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblpercent' |translate : 'Percent' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipPrecentDesc' | translate : 'Campaign discount set in percent.' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="text" [formControl]="procentValue" [(ngModel)]="campaignInfo.Value" #percent matInput value="" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errercentageexpression' | translate : 'Percentage can only contain numbers and be between 1 and 100' }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    }

    @if(rdbTime.checked) {
    <div class="row settingRow">
      <div class="col-3" style="text-align:right; top:20px;"><b>{{'T4.Campaigns.createCampaign.lblTime' |translate : 'Hours' }}</b><mat-icon matSuffix matTooltip="{{ 'T4.Campaigns.createCampaign.tipHoursDesc' | translate : 'Campaign discount set in hours' }}">help</mat-icon></div>
      <div class="col-9">
        <mat-form-field appearance="outline">
          <input type="text" [formControl]="timeValue" [(ngModel)]="campaignInfo.Value" #txtTime matInput value="" />
          <mat-error>{{ 'T4.Campaigns.CampaignList.errgreaterzeroexpression' | translate : 'Value must be only numbers and greater then 0' }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    }

  </t4-container>
</mat-dialog-content>

<mat-dialog-actions style="align-self:end">
  <button [disabled]="inputdiscountcode.errors ||
                      (campaignInfo.Type != 2 && inputMonths.errors)||
                      ( amountValue.errors  && rdbValue.checked ||
                      procentValue.errors && rdbPercent.checked) ||
                      inputValidThrough.errors && campaignInfo.Type == 2"
          mat-raised-button (click)="createCampaign()" type="button" style="margin-right: 10px;margin-left:10px; color: white; background: #33aa33; float: left;" class="btn btn-default">
    <mat-icon>assignment_turned_in</mat-icon>{{ 'T4.Campaign.createCampaign.lblcreate' | translate : 'Create'}}
  </button>
</mat-dialog-actions>
